import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthStorage } from '@utils/auth';

export interface Profile {
  name: string;
  id_admin: string;
}

export interface AuthState {
  authenticated: boolean;
  profile: Profile;
  roles: string[];
}

// Cookie에서 인증 데이터 복구하여 초기화
const initialState: AuthState = {
  authenticated: AuthStorage.isAuthenticated(),
  profile: AuthStorage.getProfile() || { name: '', id_admin: '' },
  roles: AuthStorage.getRoles(),
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthenticated: (state, { payload }: PayloadAction<boolean>) => {
      state.authenticated = payload;
    },
    setProfile: (state, { payload }: PayloadAction<Profile>) => {
      state.profile = payload;
    },
    setRoles: (state, { payload }: PayloadAction<string[]>) => {
      state.roles = payload;
    }
  }
});

export const { setAuthenticated, setProfile, setRoles } = authSlice.actions;
export default authSlice.reducer;
